// let time = parseInt(document.querySelector('.tb-ind-slideshow').getAttribute('data-time'));
// var bannerSwiper = new Swiper(".tb-ind-slideshow", {
//   autoplay: {
//     delay: time || 3000,
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
//   on: {
//     init: function (swiper) {
//       let index = this.activeIndex;
//       $('.tb-ind-slideshow .tb-ind-slideshow-item').eq(index).find('.animated').addClass('fadeIn')
//     },
//     slideChangeTransitionEnd: function () {
//       $('.tb-ind-slideshow .tb-ind-slideshow-item .animated').removeClass('fadeIn');
//       $('.tb-ind-slideshow .tb-ind-slideshow-item').eq(this.activeIndex).find('.animated').addClass('fadeIn')
//     },
//   }
// });

// $('.tb-ind-slideshow').hover(function () {
//     // over
//     bannerSwiper.autoplay.stop();
//   }, function () {
//     // out
//     bannerSwiper.autoplay.start();
//   }
// );


// var sellSwiper = new Swiper(".tb-ind-sell-swiper", {
//   autoplay: {
//     delay: 5000,
//   },
//   pagination: {
//     el: ".swiper-pagination",
//   },
//   on: {
//     init: function(swiper){
//       let index = this.activeIndex;
//       toggleFaq(index)
//     }, 
//     slideChangeTransitionStart: function(){
//       let index = this.activeIndex;
//       toggleFaq(index)
//     }
//   }
// });
// function toggleFaq(index){
//   if(!isMobile() && $(window).width() > 768){
//     $('.index-sell-faq-item').show();
//     $('.index-sell-faq-item').eq(index).addClass('active').siblings().removeClass('active');
//     $('.index-sell-faq-item').find('dd').slideUp();
//     $('.index-sell-faq-item').eq(index).find('dd').slideDown();
//   }else{
//     $('.index-sell-faq-item').eq(index).show().siblings().hide()
//   }
// }



// if(!isMobile()){
//   $('.index-sell-faq-item').click(function (e) { 
//     e.preventDefault();
//     let index = $(this).index();
//     $(this).toggleClass('active').siblings().removeClass('active');
//     $(this).siblings().find('dd').slideUp();
//     $(this).find('dd').slideToggle();
//     sellSwiper.slideTo(index, 1000, false);
//   });
//   $('.index-sell-faq-item dd').click((e) =>{e.stopPropagation()})
// }


// if(isMobile() || $(window).width() < 768){
//   $('.tb-ind-about-item').eq(0).addClass('active');
//   $('.tb-ind-about-item').click(function(){
//     $(this).toggleClass('active').siblings().removeClass('active');
//     $(this).siblings().find('dd').slideUp();
//     $(this).find('dd').slideToggle();
//   })
//   $('.tb-ind-about-item dd').click((e) =>{e.stopPropagation()})
// }



// var reviewSwiper = new Swiper(".tb-ind-reviews-swiper", {
//   slidesPerView: 1,
//   spaceBetween: 24,
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
//   on: {
//     init: function (swiper) {
//       if (isMobile() || $(window).width() <= 768) {
//         this.params.slidesPerView = 1;
//         this.params.spaceBetween = 20;
//       } else {
//         this.params.slidesPerView = 1;
//         this.params.spaceBetween = 24;
//       }
//     },
//     resize: function (swiper) {
//       if (isMobile() || $(window).width() <= 768) {
//         this.params.slidesPerView = 1;
//         this.params.spaceBetween = 20;
//       } else {
//         this.params.slidesPerView = 1;
//         this.params.spaceBetween = 24;
//       }
//       this.update();
//     },
//   },
// });




var indexBannerSwipper = new Swiper(".indexBannerSwipper", {
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".indexBannerSwipper .swiper-pagination",
  },
});

var mediaSwiper = new Swiper(".mediaSwiper", {
  slidesPerView: isMobile() ? 1 : 2,
  slidesPerGroup: isMobile() ? 1 : 2,
  loop: true,
  navigation: {
    nextEl: ".mediaSwiperBox .swiper-button-next",
    prevEl: ".mediaSwiperBox .swiper-button-prev",
  },
});

var reviewSwiper = new Swiper(".reviewSwiper", {
  slidesPerView: isMobile() ? 1.3 : 4,
  // 设定自动播放
  autoplay: {
    delay: 0,
  },
  // 设定过渡时间
  speed: 5000,
  // 应用平滑效果
  effect: 'slide',
  loop: true,
  freeMode: true,
  slidesOffsetBefore : isMobile() ? 0 : -200,
  spaceBetween: isMobile() ? 12 : 28,
  loop: true
});

var offerSwiper = new Swiper(".offerSwiper", {
  slidesPerView: isMobile() ? 1 : 3,
  spaceBetween: 24,
  pagination: {
    el: ".offerSwiper .swiper-pagination",
  },
});

var module2Swiper = new Swiper(".module2Swiper", {
  slidesPerView: 1,
  pagination: {
    el: ".module2Swiper .swiper-pagination",
  },
});